import script from "./CupSubTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CupSubTabs.vue?vue&type=script&setup=true&lang=js"

import "./CupSubTabs.vue?vue&type=style&index=0&id=e9640c5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9640c5a"]])

export default __exports__